export const locale = {
    lang: 'fr',
    data: {
        note: "Notes :",
        messages: {
            deleteFolder: 'Êtes-vous sûrs de vouloir supprimer ce dossier ?',
            deleteEstablishment: 'Êtes-vous sûrs de vouloir supprimer cette établissement ?',
            deleteLevel: 'Êtes-vous sûrs de vouloir supprimer ce niveau ?',
            deleteLevelInstance: 'Êtes-vous sûrs de vouloir supprimer cette instance ?',
            deleteRank: 'Êtes-vous sûrs de vouloir supprimer ce grade ?',
            deletesalary: 'Êtes-vous sûrs de vouloir supprimer ce niveau de salaire ?',
            deleteClientRubric: 'Êtes-vous sûrs de vouloir supprimer cette rubrique ?',
            deletePlanRubric: 'Êtes-vous sûrs de vouloir supprimer ce plan ?',
            disabledClientRubric: 'Êtes-vous sûrs de vouloir désactiver cette rubrique ?',
            confAddToPlan: 'Attention! Toutes les rubriques sous-adjacentes seront automatiquement ajoutées au plan',
            deleteLeaves: 'Êtes-vous sûrs de vouloir supprimer se congé ?',
            deleteEmployeeRubric: 'Êtes-vous sûrs de vouloir supprimer cette rubrique ?',
            manualyPointingDays: 'Le nombre de jour pointer est supérieur au nombre de jour travailler, voulez-vous vraiment continuer ?',
            deletePayroll: 'Êtes-vous sûrs de vouloir supprimer les paies du mois de ',
            deleteEmployeePay: 'êtes vous sûr de vouloir supprimer cette paie ',
            deleteGroupRubric: 'êtes vous sûr de vouloir supprimer ce groupe ? ',
            deleteRubricInGroup: 'êtes vous sûr de vouloir supprimer cette rubrique ?'
        },
        buttons: {
            ok: 'Oui',
            no: 'Non',
            cancel: 'Annuler',
            conf: 'Confirmer',
        }
    },
};
